<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <div class="select-label">订单时间:</div>
      <DatePicker v-model="timeArr" type="daterange" format="yyyy-MM-dd" placeholder="请选择订单时间" style="width: 200px" />
    </div>
    <div class="select-box input_left_two">
      <div class="select-label">应用名称:</div>
      <Select v-model="storePkgName" style="width:100px" @on-change="changeAppList">
        <Option v-for="item in appList" :value="item.package_name" :key="item.id">{{ item.name }}</Option>
      </Select>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn"  style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear" >重置</Button>
    </div>
    <div class="order_box">
      <div class="order_card">
        <Card style="width:220px">
          <div style="text-align:center">
              <h3>订单量（单）</h3>
              <h3>{{summary.sumOrderNo || 0}}</h3>
          </div>
        </Card>
        <Card style="width:220px">
            <div style="text-align:center">
                <h3>预估交易金额（元）</h3>
                <h3>{{summary.totalPayMoney || 0}}</h3>
            </div>
        </Card>
        <Card style="width:220px">
            <div style="text-align:center">
                <h3>预估佣金金额（元）</h3>
                <h3>{{summary.totalIncomeMoney || 0}}</h3>
            </div>
        </Card>
      </div>
      <div class="order_card_pay" id="pay_card">
        <!-- <Card> -->
            <!-- <div id="pay_card"></div> -->
        <!-- </Card> -->
    </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
import utils from '../utils'
export default {
  name: 'testUsers',
  data () {
    return {
      loading: true,
      timeArr: [],
      storePkgName: '',
      summary: {
        monthData: [],
        sumOrderNo: 0,
        totalPayMoney: 0,
        totalIncomeMoney: 0
      },
      appList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      // return
    }
    this.getAccount()
    // this.loadData()
  },
  mounted () {
    this.chartFun()
  },
  methods: {
    formatDay: utils.formatDay,
    // 加载tabs列表
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.timeArr = []
      this.storePkgName = ''
      this.loadData()
    },
    getAccount () {
      https.request({
        method: 'GET',
        url: '/v2/es/account',
        params: {}
      }).then(res => {
        this.getAppList(res.id)
      })
    },
    getAppList (id) {
      let params = {
        page_size: 100,
        page: 1,
        uid: id
      }
      https.request({
        method: 'get',
        url: 'v2/es/apps',
        params: params
      }).then(res => {
        this.appList = res.data.items
        this.storePkgName = res.data.items[0].package_name
      })
    },
    changeAppList (val) {
      console.log(val)
      this.storePkgName = val
    },
    chartFun (item = null) {
      item = [
        {
          date: '2023-04-03',
          totalAmonut: 8,
          orderNum: 3
        },
        {
          date: '2023-04-04',
          totalAmonut: 19,
          orderNum: 8
        },
        {
          date: '2023-04-05',
          totalAmonut: 8,
          orderNum: 8
        },
        {
          date: '2023-04-06',
          totalAmonut: 10,
          orderNum: 18
        },
        {
          date: '2023-04-07',
          totalAmonut: 8,
          orderNum: 8
        },
        {
          date: '2023-04-08',
          totalAmonut: 6,
          orderNum: 28
        },
        {
          date: '2023-04-09',
          totalAmonut: 8,
          orderNum: 8
        },
        {
          date: '2023-04-10',
          totalAmonut: 8,
          orderNum: 8
        }
      ]
      let data = []
      let data1 = []
      let data2 = []
      item.map(items => {
        data.push(items.date)
        data1.push(items.orderNum)
        data2.push(items.totalAmonut)
      })
      let chartDom = document.getElementById('pay_card')
      let myChart = echarts.init(chartDom)
      let option
      option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['订单量', '预估交易金额']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          data: data
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '订单量',
            data: data1,
            type: 'line',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          },
          {
            name: '预估交易金额',
            data: data2,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    loadData () {
      if (this.timeArr.length < 1) {
        console.log('请选择时间')
        return
      }
      let params = {
        s_date: '',
        e_date: '',
        store_pkg_name: this.storePkgName
      }
      let year = this.timeArr[0].getFullYear()
      let month = this.timeArr[0].getMonth() + 1 < 10 ? `0${this.timeArr[0].getMonth() + 1}` : this.timeArr[0].getMonth() + 1
      let day = this.timeArr[0].getDate() < 10 ? `0${this.timeArr[0].getDate()}` : this.timeArr[0].getDate()
      let yearE = this.timeArr[1].getFullYear()
      let monthE = this.timeArr[1].getMonth() + 1 < 10 ? `0${this.timeArr[1].getMonth() + 1}` : this.timeArr[1].getMonth() + 1
      let dayE = this.timeArr[1].getDate() < 10 ? `0${this.timeArr[1].getDate()}` : this.timeArr[1].getDate()
      params.s_date = `${year}-${month}-${day}`
      params.e_date = `${yearE}-${monthE}-${dayE}`
      https.request({
        method: 'get',
        url: '/v2/es/dc/summary',
        params: params
      }).then(res => {
        this.summary = res.data
        this.chartFun(res.data.monthData)
      }).catch(error => {
        this.$Message.error(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spacingTwice{
    margin-top:30px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
    .input_left{
    // left:516px;
    left:131px;
  }
  .input_left_two{
    // left:700px;
    left:370px;
  }
  .input_left_three{
    // left:885px;
    left:613px;
  }
  .order_box{
    display: flex;
    margin-top:60px;
    .order_card{
      width:240px;
    }
    .order_card_pay{
      width:500px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dataCenter.vue